import { Link } from 'wouter'
import Icon from 'components/Icon'

import './TicketItem.css'

import getTimeAgo from 'tools/getTimeAgo'

const TicketItem = ({ path, id, summary, type, priority, status, updated }) => {
  return (
    <>
      <Link href={path ? `${path}/${id}` : `/ticket/${id}`}>
        <tr id={id} className='TicketItem'>
          <td><Icon name={type} /></td>
          <td><Icon name={priority} /></td>
          <td><Icon name={status} /></td>
          <td>{summary}</td>
          <td><span className='updated'>{getTimeAgo(updated)}</span></td>
        </tr>
      </Link>
    </>
  )
}

export default TicketItem
